import styles from './input.module.scss';

const Input = (props) => {
  return (
    <>
      <input {...props} className={`${styles.input} ${props.className} ${props.isinvalid ? styles.isInvalid : ''}`} />
    </>
  );
};

export default Input;
